import React, { ChangeEvent, Component } from "react";
import shopifyLogo from "../../../../assets/images/shopify/shopify-logo.svg";
import shopifyLightLogo from "../../../../assets/images/shopify/shopify-logo-light.svg";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetPriceGroupsDTO from "../../../../models/DTO/IGetPriceGroupsDTO";
import ILoadUserDTO from "../../../../models/DTO/ILoadUserDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnShopifyBeginOAuthDTO from "../../../../models/DTO/IOnShopifyBeginOAuthDTO";
import IOnShopifyDisconnectDTO from "../../../../models/DTO/IOnShopifyDisconnectDTO";
import IShopifyBeginOAuthDTO from "../../../../models/DTO/IShopifyBeginOAuthDTO";
import IShopifyDisconnectDTO from "../../../../models/DTO/IShopifyDisconnectDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICatalog from "../../../../models/ICatalog";
import INotification from "../../../../models/INotification";
import IPrice_Group from "../../../../models/IPrice_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import IShopify from "../../../../models/IShopify";
import { ShopifyShopModal } from "./ShopifyShopModal/ShopifyShopModal";
import Modal from "react-modal";
import { OwIconButton } from "../../../shared/OwIconButton/OwIconButton";
import IShopifyUpdateShopDTO from "../../../../models/DTO/IShopifyUpdateShopDTO";
import UserService from "../../../../services/UserService";
import IShopifyDeleteShopDTO from "../../../../models/DTO/IShopifyDeleteShopDTO";
import IShopifyOnDeleteShopDTO from "../../../../models/DTO/IShopifyOnDeleteShopDTO";
import { Socket } from "socket.io-client";
import IShopifyCreateShopDTO from "../../../../models/DTO/IShopifyCreateShopDTO";
import IShopifyOnCreateShopDTO from "../../../../models/DTO/IShopifyOnCreateShopDTO";
import { ShopifyShopModalPrivateApp } from "./ShopifyShopModalPrivateApp/ShopifyShopModalPrivateApp";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    isMainViewLight?: boolean;
};

type State = {
    shopify_shop: string;
    catalogs: ICatalog[];
    priceGroups: IPrice_Group[];
    default_catalog_id?: number;
    default_price_group_id?: number;
    selectedCatalog?: ICatalog;
    saveActive: boolean;
    connectActive: boolean;
    modalComponent?: any;
    modalIsOpen: boolean;
    modalStyle: {
        content: {
            top: string;
            left: string;
            right: string;
            bottom: string;
            color: string;
            backgroundColor: string;
            border: string;
        };
        overlay: {
            zIndex: number;
        };
    };
};

class ShopifyConnect extends Component<Props, State> {
    readonly state: State = {
        shopify_shop: this.props.supplierModel.Supplier_Integration.shopify_shop || "",
        catalogs: [],
        priceGroups: [],
        default_catalog_id: this.props.supplierModel.Supplier_Integration.shopify_options?.default_catalog_id,
        default_price_group_id: this.props.supplierModel.Supplier_Integration.shopify_options?.default_price_group_id,
        saveActive: false,
        connectActive: false,
        modalIsOpen: false,
        modalStyle: {
            content: {
                top: "10px",
                left: "10px",
                right: "10px",
                bottom: "10px",
                color: "var(--main-text-color)",
                backgroundColor: "var(--main-bg-color)",
                border: "1px solid var(--minor-bg-color)",
            },
            overlay: {
                zIndex: 100,
            },
        },
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.ShopifyOnBeginOAuth, this.onShopifyBeginOAuth);
        this.props.socket.on(EndpointsEnum.ShopifyOnDisconnect, this.onDisconnect);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetPriceGroups, this.onGetPriceGroups);
        this.props.socket.on(EndpointsEnum.ShopifyOnDeleteShop, this.onDeleteShop);
        this.props.socket.on(EndpointsEnum.ShopifyOnCreateShop, this.onCreateShop);

        this.getCatalogs();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.ShopifyOnBeginOAuth, this.onShopifyBeginOAuth);
        this.props.socket.removeListener(EndpointsEnum.ShopifyOnDisconnect, this.onDisconnect);
        this.props.socket.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.removeListener(EndpointsEnum.CatalogsOnGetPriceGroups, this.onGetPriceGroups);
        this.props.socket.removeListener(EndpointsEnum.ShopifyOnDeleteShop, this.onDeleteShop);
        this.props.socket.removeListener(EndpointsEnum.ShopifyOnCreateShop, this.onCreateShop);
    }

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "ShopifyConnect",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        let selectedCatalog: ICatalog | undefined;

        if (this.state.default_catalog_id) {
            selectedCatalog = data.catalogs.find((catalog) => {
                return catalog.id === Number(this.state.default_catalog_id);
            });
        }

        this.setState(
            {
                catalogs: data.catalogs,
                selectedCatalog,
            },
            () => {
                if (this.state.selectedCatalog) {
                    this.getPriceGroups();
                }
            }
        );
    };

    getPriceGroups = () => {
        const payload: IGetPriceGroupsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.selectedCatalog!.guid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        this.setState({
            priceGroups: data.priceGroups,
        });
    };

    update = (payload: IShopifyUpdateShopDTO) => {
        this.props.socket.emit(EndpointsEnum.ShopifyUpdateShop, payload);

        this.setState({
            connectActive: true,
        });
    };

    connect = (payload: IShopifyBeginOAuthDTO) => {
        this.props.socket.emit(EndpointsEnum.ShopifyBeginOAuth, payload);

        this.setState({
            connectActive: true,
        });
    };

    disconnect = (shopifyShop: IShopify) => {
        const payload: IShopifyDisconnectDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shopGuid: shopifyShop.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShopifyDisconnect, payload);
    };

    onDisconnect = (data: IOnShopifyDisconnectDTO) => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    onShopifyBeginOAuth = (data: IOnShopifyBeginOAuthDTO) => {
        window.location.href = data.url;
    };

    createShop = (payload: IShopifyCreateShopDTO) => {
        this.props.socket.emit(EndpointsEnum.ShopifyCreateShop, payload);

        this.setState({
            connectActive: true,
        });
    };

    onCreateShop = (data: IShopifyOnCreateShopDTO) => {
        const notification: INotification = {
            message: "successfully_added_shop",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                connectActive: false,
            },
            () => {
                this.loadUser();
            }
        );
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        let selectedCatalog = this.state.selectedCatalog;

        if (name === "default_catalog_id") {
            selectedCatalog = this.state.catalogs.find((catalog) => {
                return catalog.id === Number(value);
            });
            state.selectedCatalog = selectedCatalog;
        }

        this.setState(state, () => {
            if (name === "default_catalog_id" && this.state.selectedCatalog) {
                this.getPriceGroups();
            }
        });
    };

    saveShopifyDefaults = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                shopify_options: {
                    default_price_group_id: this.state.default_price_group_id,
                    default_catalog_id: this.state.default_catalog_id,
                },
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            saveActive: true,
        });
    };

    onUpdateSupplierIntegrations = () => {
        const notification: INotification = {
            message: "successfully_updated_supplier_integrations",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            saveActive: false,
        });
    };

    closeModal = () => {
        this.setState(
            {
                modalComponent: null,
                modalIsOpen: false,
            },
            () => {
                this.loadUser();
            }
        );
    };

    showShopifyModal = () => {
        // this was previously used for shopify with oauth, however due to their crazy requirements of billins
        // we have had to abondon this approach.
        const modalComponent = (
            <ShopifyShopModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                catalogs={this.state.catalogs}
                update={this.update}
                create={this.connect}
                isMainViewLight={this.props.isMainViewLight}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    showShopifyPrivateAppModal = () => {
        const modalComponent = (
            <ShopifyShopModalPrivateApp
                closeModalFn={this.closeModal}
                catalogs={this.state.catalogs}
                update={this.update}
                create={this.createShop}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    editShop = (shop: IShopify) => {
        const modalComponent = (
            <ShopifyShopModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                catalogs={this.state.catalogs}
                shopifyShop={shop}
                update={this.update}
                create={this.connect}
                isMainViewLight={this.props.isMainViewLight}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    confirmDelete = (shop: IShopify, e?: ChangeEvent<any>) => {
        const payload: IShopifyDeleteShopDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shopGuid: shop.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShopifyDeleteShop, payload);
    };

    onDeleteShop = (data: IShopifyOnDeleteShopDTO) => {
        const notification: INotification = {
            message: "successfully_removed_shop",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.loadUser();
    };

    loadUser = () => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    render() {
        let logo = shopifyLogo;

        if (this.props.isMainViewLight) {
            logo = shopifyLightLogo;
        }

        const hasShopify = !!this.props.supplierModel.Supplier_Integration.has_shopify;

        return (
            <div className="ShopifyConnect">
                <OwAccordion
                    hideChevron={!hasShopify}
                    leftImage={logo}
                    leftImageAlt={"Shopify"}
                    leftImageHeight={30}
                    titleClick={hasShopify}
                    rightElem={
                        <div className={"ms-auto"}>
                            <OwButton title={"add_shopify_shop"} fn={this.showShopifyPrivateAppModal} />
                        </div>
                    }>
                    <div className={"title d-flex"}>
                        <div>
                            {hasShopify ? (
                                <div>
                                    <div className={"d-flex"}>
                                        <div className="w-10r"></div>
                                        <div className="w-20r">
                                            <OwLabel title={"shop_name"} />
                                        </div>
                                        <div className="w-10r">
                                            <OwLabel title={"catalog"} />
                                        </div>
                                        <div className="w-10r">
                                            <OwLabel title={"price_group"} />
                                        </div>
                                        <div className="w-15r">
                                            <OwLabel title={"last_inventory_update"} />
                                        </div>
                                        <div className="w-15r">
                                            <OwLabel title={"last_orders_pulled"} />
                                        </div>
                                    </div>
                                    {(this.props.supplierModel.Shopifies || []).map((shopify) => {
                                        return (
                                            <div key={shopify.guid} className={"d-flex w-100"}>
                                                <div className={"w-10r"}>
                                                    <OwIconButton
                                                        iconClass={"fad fa-pencil me-2"}
                                                        iconColorClass={"text-primary"}
                                                        fn={(e?: ChangeEvent<any>) => {
                                                            this.editShop(shopify);
                                                        }}
                                                    />
                                                    <OwIconButton
                                                        iconClass={"fad fa-trash-alt"}
                                                        iconColorClass={"text-danger"}
                                                        fn={(e?: ChangeEvent<any>) => {
                                                            this.confirmDelete(shopify, e);
                                                        }}
                                                    />
                                                </div>
                                                <div className={"w-20r"}>{shopify.shopify_shop}</div>
                                                <div className={"w-10r"}>{shopify.Catalog?.name}</div>
                                                <div className={"w-10r"}>{shopify.Price_Group?.value}</div>
                                                <div className="w-15r">
                                                    {shopify.last_inventory_update
                                                        ? UserService.parseLastUpdated(shopify.last_inventory_update, true, true, true)
                                                        : "N/A"}
                                                </div>
                                                <div className="w-15r">
                                                    {shopify.last_orders_pulled
                                                        ? UserService.parseLastUpdated(shopify.last_orders_pulled, true, true, true)
                                                        : "N/A"}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </OwAccordion>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}
                        style={this.state.modalStyle}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default ShopifyConnect;
